<template>
	<modal ref="modal">
		<template #title>UPDATE STOCK DETAILS CONTENT</template>
		<template #body>
			<div class="text-center mb-4 h3">
				<span class="badge bg-success">STOCK: {{stockDetails.stock}}</span>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.company_title" id="company_title" name="company_title" class="form-control" placeholder="Company Name" />
				<label class="form-label" for="company_title">Company Name</label>
			</div>
			<div class="form-floating mb-4">
				<div class="mb-4">
					<label class="form-label" for="company_logo">Company Logo</label>
					<div class="fw-bold text-danger">Recommended Size: width:1150px height:648px</div>
					<input
						@change="onFileChange"
						type="file"
						id="company_logo"
						name="company_logo"
						class="form-control"
						:accept="[
			            'image/jpeg',
			            'image/jpg',
			            'image/png'
			          ]"
					/>
				</div>
				<div class="mb-4">
					<div v-if="form.prev_company_logo!=null"
						class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
						style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
						:class="{'opacity-25':(form.company_logo!=form.prev_company_logo && form.prev_company_logo!=null && form.stock_details_id>0)}"
					>
						<img :src="form.company_logo_url" style="width:100%;" />
					</div>
					<div v-if="form.company_logo!=form.prev_company_logo && form.prev_company_logo!=null && form.stock_details_id>0" class="text-center text-muted">
						<i class="fa fa-arrow-down fa-2x"></i>
					</div>
					<div>
						<div id="image-preview"
							class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
							style="background-size: contain;background-repeat: no-repeat;background-position: center;"
							:style="{'height':(form.company_logo!=form.prev_company_logo)?'300px':'0px'}"
						>
							
						</div>
						<div v-if="form.company_logo!=form.prev_company_logo && form.prev_company_logo!=null && form.stock_details_id>0" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
					</div>
				</div>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="description">Description</label>
				<!-- <CKEditor v-model="form.description" :editor="editor" :config="editorConfig"></CKEditor> -->
				<textarea id="ckeditor_stockdetails"></textarea>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.sector" id="sector" name="sector" class="form-control" placeholder="Sector" />
				<label class="form-label" for="sector">Sector</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.sub_sector" id="sub_sector" name="sub_sector" class="form-control" placeholder="Sub Sector" />
				<label class="form-label" for="sub_sector">Sub Sector</label>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="form.listing_date"
					id="listing_date"
					name="listing_date"
					class="form-control form-control-sm"
					:config="{
						altInput: true,
						altFormat: 'M j, Y',
						dateFormat: 'Y-m-d',
						wrap: true,
					}"
					placeholder="Listing Date"
				/>
				<label class="form-label" for="listing_date">Listing Date</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.website" id="website" name="website" class="form-control" placeholder="Website" />
				<label class="form-label" for="website">Website</label>
			</div>
		</template>
		<template #footer>
			<button 
				@click="updateContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditorInit from './../../Shared/ckeditor-init';

export default {
	props: {
		
	},
	mounted(){
		CKEditorInit('ckeditor_stockdetails');
	},
	setup(props) {
		const modal = ref(null)

		// const editor 		= ref(ClassicEditor);
		// const editorConfig 	= reactive({});

		const toggleModal = () => {

			window['ckeditor_stockdetails'].setData(form.description);

			modal.value.toggleModal()
		}

		const form = useForm({
			stock_details_id 	: 0,
			stock 				: '',
			company_title 		: '',
			company_logo 		: null,
			prev_company_logo 	: null,
			company_logo_url 	: null,
			description 		: '',
			sector 				: '',
			sub_sector 			: '',
			listing_date 		: '',
			website 			: '',
		})

		const stockDetails = reactive({})

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#company_logo").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.company_logo = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.company_logo = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.company_logo = form.prev_company_logo;
			clearUpload();
		}

		const updateContent = () => {
			form.description = window['ckeditor_stockdetails'].getData();
			form.post('sam-table/stock-details/'+form.stock_details_id, {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['stocks,search,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setStockDetailsContent = (data)=>{
								
								form.reset();
								Object.assign(stockDetails,data);

								form.stock 				= data.stock;

								if(data.stock_details!==null)
								{
									form.stock_details_id 	= data.stock_details.stock_details_id;
									form.company_title 		= data.stock_details.company_title;
									form.company_logo 		= data.stock_details.company_logo;
									form.prev_company_logo 	= data.stock_details.prev_company_logo;
									form.company_logo_url 	= data.stock_details.company_logo_url;
									form.description 		= data.stock_details.description;
									form.sector 			= data.stock_details.sector;
									form.sub_sector 		= data.stock_details.sub_sector;
									form.listing_date 		= data.stock_details.listing_date;
									form.website 			= data.stock_details.website;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			stockDetails,
			clearUpload,
			onFileChange,
			removeUploadImage,
			// editor,
			// editorConfig,
			setStockDetailsContent,
			updateContent,
		}
	},
}
</script>
<style>
	.ck-content{
		height: 300px;
	}
</style>